const scrollOnEvent = {
	el: {
		header: document.querySelector('.header'),
		heroBooking: document.querySelector('.hero-headline--no-pattern')
	},

	vars: {
		timeToStartScroll: 300,
		headerHeight: document.querySelector('.header').offsetHeight
	},

	fxScrollOnEvent(el) {
		const elementOffset = el.offsetTop,
			elementFinalOffset = elementOffset - this.vars.headerHeight

		setTimeout(() => window.scrollTo(0, elementFinalOffset), this.vars.timeToStartScroll)
	},

	fxScrollSmoothOnEvent(el) {
		const elementOffset = el.offsetTop,
			elementFinalOffset = elementOffset - this.vars.headerHeight

		setTimeout(() => window.scrollTo({ top: elementFinalOffset, behavior: 'smooth' }), this.vars.timeToStartScroll)
	},

	init() {
		this.el.heroBooking && this.fxScrollOnEvent(this.el.heroBooking)
	}
}

scrollOnEvent.init()